import axios from 'axios';
import {ApiService} from './api.service';
import {LocalStorageService} from './local-storage.service';
import {AuthService} from './auth.service';
import {AuthStorageService} from './auth-storage.service';
import {LicenseService} from './license.service';
import {CompanyService} from './company.service';
import {UserService} from './user.service';
import {ErrorHandler} from './error-handler.service';
import appConfig from '../app.config';

const localStorageService = new LocalStorageService(localStorage);
const authStorageService = new AuthStorageService(localStorageService, 'auth');
const apiService = new ApiService(axios, appConfig.apiUrl, appConfig.apiRequestTimeout, authStorageService, new ErrorHandler());
const authService = new AuthService(apiService, authStorageService, 'auth');
const licenseService = new LicenseService(apiService);
const companyService = new CompanyService(apiService);
const userService = new UserService(apiService);

export {
  apiService,
  authService,
  authStorageService,
  localStorageService,
  licenseService,
  companyService,
  userService
};
